export function operacaoVazamentoInRequest(params = {}) {
  return {
    type: '@operacaovazamento/VAZAMENTO_IN_REQUEST',
    payload: { params },
  };
}

export function findOperacaoVazamento(movi_codigo) {
  return {
    type: '@operacaovazamento/FIND_VAZAMENTO',
    payload: { movi_codigo },
  };
}

export function failedRequest() {
  return {
    type: '@operacaovazamento/FAILED_REQUEST',
  };
}

export function deleteOperacaoVazamento(movi_codigo, params) {
  return {
    type: '@operacaovazamento/DELETE_VAZAMENTO',
    payload: { movi_codigo, params },
  };
}

export function updateOperacaoVazamento(operacaovazamento, params) {
  return {
    type: '@operacaovazamento/UPDATE_VAZAMENTO',
    payload: { operacaovazamento, params },
  };
}

export function storOperacaoVazamento(operacaovazamento, params) {
  return {
    type: '@operacaovazamento/STORE_VAZAMENTO',
    payload: { operacaovazamento, params },
  };
}

export function successInRequest(
  operacaovazamento,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@operacaovazamento/SUCCESS_IN_REQUEST',
    payload: { operacaovazamento, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(operacaovazamento) {
  return {
    type: '@operacaovazamento/SUCCESS_REQUEST',
    payload: { operacaovazamento },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaovazamento/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaovazamento/RECORD_FILTERING',
    payload: { params },
  };
}
